import { ChangeDetectionStrategy, Component, computed, input, model } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Dialog } from 'primeng/dialog';
import { ClientProfileComponent } from '../../client-profile/client-profile/client-profile.component';
import type { HouseholdMemberRow } from '../member-metadata-header.model';

/**
 * Stacked profile dialog for a non-primary household member (MW-10562 OQ-11).
 * Hosts {@link ClientProfileComponent} with the member GUID; closing returns to the
 * household roster dialog (parent stays open).
 */
@Component({
  selector: 'bn-household-member-profile-modal',
  imports: [CommonModule, Dialog, ClientProfileComponent],
  templateUrl: './household-member-profile-modal.component.html',
  styleUrl: './household-member-profile-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HouseholdMemberProfileModalComponent {
  /** Member whose profile is shown; null when closed. */
  readonly member = input<HouseholdMemberRow | null>(null);
  /** Two-way dialog visibility. */
  readonly visible = model(false);

  readonly title = computed(() => {
    const m = this.member();
    if (!m) {
      return 'Member profile';
    }
    return `${m.firstName} ${m.lastName}`.trim() || 'Member profile';
  });

  readonly memberGuid = computed(() => this.member()?.guid?.trim() || null);

  close(): void {
    this.visible.set(false);
  }
}
